import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import EmailManagerContent from "./EmailManagerContent";

import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";

const EmailManager = () => {
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "40px",
          width: "100%",
          backgroundColor: "var(--default-light)",
        }}
      >
        <ShepTabs
          variant="tertiary"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="workflow tabs"
        >
          <ShepTab
            variant="tertiary"
            key="1"
            label={"Inbound"}
            iconPosition="start"
          />
        </ShepTabs>
      </div>
      <Box sx={{ maxHeight: "100%" }}>
        {tabValue === 0 && <EmailManagerContent />}
      </Box>
    </Container>
  );
};
export default EmailManager;
